import React, { useEffect, useRef } from "react";
import { FaShieldAlt, FaBolt, FaCheck } from "react-icons/fa";

const STATS = [
  { icon: <FaBolt />, value: "24/7", label: "Pix instantâneo" },
  { icon: <FaShieldAlt />, value: "100%", label: "digital e seguro" },
];

export const About = (props) => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const currentAbout = aboutRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentAbout) {
      observer.observe(currentAbout);
    }

    return () => {
      if (currentAbout) {
        observer.unobserve(currentAbout);
      }
    };
  }, []);

  const renderParagraphs = () => {
    if (!props.data) return <p className="paragraph">loading...</p>;

    const paragraphs = [];
    for (let i = 0; i <= 10; i++) {
      const key = i === 0 ? "paragraph" : `paragraph${i}`;
      if (props.data[key]) {
        paragraphs.push(
          <p className="paragraph" key={key}>
            {props.data[key]}
          </p>
        );
      }
    }
    return paragraphs;
  };

  const why = props.data?.Why || [];
  const why2 = props.data?.Why2 || [];
  const pills = [...why, ...why2];

  return (
    <section id="about" ref={aboutRef}>
      <div className="container">
        <div className="about-grid">
          <div className="about-content">
            <span className="about-eyebrow">
              <span className="about-eyebrow-dot" aria-hidden="true"></span>
              Sobre o {props.data ? props.data.nameBank : "CORE bank"}
            </span>
            <h2>
              Banking digital, do jeito que o seu dia pede
            </h2>

            {renderParagraphs()}

            <div className="about-pills" aria-label="Diferenciais CORE bank">
              {pills.map((label, i) => (
                <span key={`${label}-${i}`} className="about-pill">
                  <FaCheck className="about-pill-icon" aria-hidden="true" />
                  {label}
                </span>
              ))}
            </div>
          </div>

          <div className="about-visual">
            <div className="about-image-wrap">
              <div className="about-image-glow" aria-hidden="true"></div>
              <img
                src="img/bout.png"
                className="about-image"
                alt={`Aplicativo ${props.data ? props.data.nameBank : "CORE bank"}`}
              />
            </div>

            <div
              className={`about-stats-card about-stats-card--${STATS.length}`}
              aria-label="Estatísticas CORE bank"
            >
              {STATS.map((stat, i) => (
                <div key={i} className="about-stat">
                  <span className="about-stat-icon" aria-hidden="true">
                    {stat.icon}
                  </span>
                  <div className="about-stat-text">
                    <strong className="about-stat-value">{stat.value}</strong>
                    <span className="about-stat-label">{stat.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
